import EnjoyHint from 'xbs-enjoyhint/src/enjoyhint'

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl, {html: true, placement: 'bottom'})
})


$('#upload-send-button').on('click', function () {
    $('#upload-modal').modal('show');
})

$('#select-categories').on('change', function () {
    tool.refresh.category()
})

$('#select-biomes').on('change', function () {
    tool.refresh.biome()
})

const tool = {
    area: null,
    workspace: '/platform',
    refresh: {
        biome: () => {
            $.ajax({ url: `${tool.workspace}/category/${$('#select-biomes').val()}` }).done(function (categories) {
                var $el = $("#select-categories")
                $el.empty()
                $.each(categories, function (key, categorie) {
                    $el.append($("<option></option>").attr("value", categorie.id).text(categorie.name))
                })
                $('#select-categories').trigger('chosen:updated');
                tool.refresh.category()
            })
        },
        category: () => {
            $.ajax({ url: `${tool.workspace}/categories/${$('#select-categories').val()}/areas`  }).done(function (areas) {
                var $el = $("#select-areas")
                $el.empty()
                $.each(areas, function (key, area) {
                    $el.append($("<option></option>").attr("value", area.id).text(area.name))
                })
                $('#select-areas').trigger('chosen:updated');    
            })
        }
    }
}